import { useMemo, useRef, useState } from 'react';
import { CollectionImage } from '~/components/collections';
import arrowLeft from '~/assets/icons/arrow_left_2.svg';
import cross from '~/assets/icons/cross.svg';
import {
	setCategorySelectVisible,
	setCreateVisible,
	setItemSelectVisible,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import realtyExample from '../../assets/images/realty_example.jpg';
import { TextLabel } from '../TextLabel';
import { AppAdsTypes } from '../AppAds';
import { VehiclePlateBig } from '../VehiclePlateBig';
import { selectTitle } from './AppAdsItemSelect.model';
import {
	StyledContainer,
	StyledHeadContainer,
	StyledBackButton,
	StyledCrossButton,
	StyledItemsContainer,
	StyledRealtyContainer,
	StyledContinueButton,
	StyledVehicleContainer,
	StyledPlateContainer,
	StyledOverlay,
	StyledCollectionImageContainer,
} from './AppAdsItemSelect.styled';

const AppAdsItemSelect = () => {
	const dispatch = useLayoutDispatch();
	const createCategory = useLayoutSelector((state) => state.ads.createCategory);
	const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
	const [opacity, setOpacity] = useState(1);
	const containerRef = useRef(null);

	const buttonActive = useMemo(() => selectedIndex !== null, [selectedIndex]);

	const handleScroll = () => {
		if (!containerRef.current) return;

		const container = containerRef.current as any;
		const scrollBottom =
			container?.scrollHeight - container?.scrollTop - container?.clientHeight;

		if (scrollBottom <= 20) {
			const newOpacity = scrollBottom / 20;
			setOpacity(newOpacity);
		} else {
			setOpacity(1);
		}
	};

	return (
		<StyledContainer>
			<StyledHeadContainer>
				<StyledBackButton
					onClick={() => {
						dispatch(setItemSelectVisible(false));
						dispatch(setCategorySelectVisible(true));
					}}
				>
					<img src={arrowLeft} />
					<TextLabel>Вернуться назад</TextLabel>
				</StyledBackButton>
				<TextLabel
					style={{
						fontSize: 14,
						color: '#ffffff',
						opacity: 0.5,
						textAlign: 'center',
					}}
				>
					{selectTitle[createCategory]}
				</TextLabel>
				<StyledCrossButton
					onClick={() => dispatch(setItemSelectVisible(false))}
				>
					<img src={cross} />
				</StyledCrossButton>
			</StyledHeadContainer>
			<StyledItemsContainer onScroll={handleScroll} ref={containerRef}>
				{createCategory === AppAdsTypes.Realty &&
					new Array(12).fill(0).map((_, index) => (
						<StyledRealtyContainer
							$active={selectedIndex === index}
							key={index}
							onClick={() => setSelectedIndex(index)}
						>
							<img src={realtyExample} />
							<TextLabel>Квартира №{(index + 1) * 10}</TextLabel>
						</StyledRealtyContainer>
					))}
				{createCategory === AppAdsTypes.Vehicle &&
					new Array(12).fill(0).map((_, index) => (
						<StyledVehicleContainer
							$active={selectedIndex === index}
							key={index}
							onClick={() => setSelectedIndex(index)}
						>
							<TextLabel>BMW M5 F90</TextLabel>
							<StyledCollectionImageContainer>
								<CollectionImage
									collection={'vehicles'}
									size={81}
									id={'gaz_2410'}
								/>
							</StyledCollectionImageContainer>
							<StyledPlateContainer>
								<VehiclePlateBig number={'О744ОО'} region={'38'} />
							</StyledPlateContainer>
						</StyledVehicleContainer>
					))}
				<StyledOverlay style={{ opacity: opacity }} />
			</StyledItemsContainer>
			<StyledContinueButton
				disabled={!buttonActive}
				onClick={() => {
					dispatch(setItemSelectVisible(false));
					dispatch(setCreateVisible(true));
				}}
			>
				{buttonActive ? 'Продолжить' : selectTitle[createCategory]}
			</StyledContinueButton>
		</StyledContainer>
	);
};

export { AppAdsItemSelect };
